import React from "react";

import { Row, Col, Input, Pagination } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Laws/Laws.css";

//JS Files
import LawsList          from "./LawsList.js";

const LawsMain = props => {
     return props.size === "laptopdesktop" ? (
          <div className="LawsBackground">
               <div style={{paddingTop:"100px"}}>
                    <Center>
                              <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft"><strong>قوانین و مقرارت</strong></p>
                    </Center>
                    <Center>
                         <Margin top={2}>
                              <p className="mainTitleDescription">لیست قوانین و مقرارت بیمه مرکزی جمهوری اسلامی</p>
                         </Margin>
                    </Center>
               </div>
               <Row style={{marginTop:"75px"}}>
                    <Col span={4}></Col>
                    <Col span={16}>
                         <Row>
                              <Col span={16} style={{backgroundColor: "#ededed", borderRadius:"20px 0 0 20px", padding:"12.5px"}}>
                                   <LawsList size="laptopdesktop" link="/generalone" color="#fff" title="قانون مبارزه با پولشویی" number="1"/>
                                   <LawsList size="laptopdesktop" link="/generaltwo" color="#f9f9f9" title="قانون ارتقا سلامت نظام اداری" number="2"/>
                              </Col>
                              <Col span={8} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#f9f9f9", borderTopRightRadius: "20px", borderBottomRightRadius: "20px", paddingRight: "50px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}>
                                   <div className="miniCardTitleBorder" style={{
                                        position: 'absolute', left: '50%', top: '50%',
                                        transform: 'translate(-50%, -50%)'
                                   }}>
                                        <p className="miniCardTitle"><strong>قوانین عمومی</strong></p>
                                   </div>
                              </Col>
                         </Row>
                    </Col>
                    <Col span={4}></Col>
               </Row>
               <Margin top={4}></Margin>
               <Row>
                    <Col span={4}></Col>
                    <Col span={16}>
                         <Row>
                              <Col span={16} style={{backgroundColor: "#ededed", borderRadius:"20px 0 0 20px", padding:"12.5px"}}>
                                   <LawsList size="laptopdesktop" link="/specificone"    color="#fff"       title="قانون بیمه" number="1"/>
                                   <LawsList size="laptopdesktop" link="/specifictwo"    color="#f9f9f9"    title="قانون تاسیس بیمه مرکزی ایران و بیمه گری" number="2"/>
                                   <LawsList size="laptopdesktop" link="/specificthree"  color="#fff"       title="قانون تاسیس موسسات بیمه غیر دولتی" number="3"/>
                                   <LawsList size="laptopdesktop" link="/specificfour"   color="#f9f9f9"    title="قانون اصلاح قانون چگونگی اداره مناطق آزاد تجاری" number="4"/>
                                   <LawsList size="laptopdesktop" link="/specificfive"   color="#fff"       title="قانون شخص ثالث" number="5"/>
                              </Col>
                              <Col span={8} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#f9f9f9", borderTopRightRadius: "20px", borderBottomRightRadius: "20px", paddingRight: "50px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)"}}>
                                   <div className="miniCardTitleBorder" style={{
                                        position: 'absolute', left: '50%', top: '50%',
                                        transform: 'translate(-50%, -50%)'
                                   }}>
                                        <p className="miniCardTitle"><strong>قوانین اختصاصی</strong></p>
                                   </div>
                              </Col>
                         </Row>
                    </Col>
                    <Col span={4}></Col>
               </Row>
          </div>

     ) : props.size === "tablet" ? (
          <div className="LawsBackground">
               <div style={{ paddingTop: "75px" }}>
                    <Center>
                         <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"><strong>قوانین و مقرارت</strong></p>
                    </Center>
                    <Center>
                         <Margin top={2}>
                              <p className="mainTitleDescriptionTablet">لیست قوانین و مقرارت بیمه مرکزی جمهوری اسلامی</p>
                         </Margin>
                    </Center>
               </div>
               <Row style={{ marginTop: "25px" }}>
                    <Col span={1}></Col>
                    <Col span={22}>
                         <Row>
                              <Col span={14} style={{ backgroundColor: "#ededed", borderRadius: "20px 0 0 20px", padding: "12.5px" }}>
                                   <LawsList size="tablet" link="/generalone" color="#fff" title="قانون مبارزه با پولشویی" number="1" />
                                   <LawsList size="tablet" link="/generaltwo" color="#f9f9f9" title="قانون ارتقا سلامت نظام اداری" number="2" />
                              </Col>
                              <Col span={10} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#f9f9f9", borderTopRightRadius: "20px", borderBottomRightRadius: "20px", paddingRight: "50px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}>
                                        <div className="miniCardTitleBorder" style={{
                                             position: 'absolute', left: '50%', top: '50%',
                                             transform: 'translate(-50%, -50%)'
                                        }}>
                                             <p className="miniCardTitleTablet"><strong>قوانین عمومی</strong></p>
                                   </div>
                              </Col>
                         </Row>
                    </Col>
                    <Col span={1}></Col>
               </Row>
               <Margin top={4}></Margin>
               <Row>
                    <Col span={1}></Col>
                    <Col span={22}>
                         <Row>
                              <Col span={14} style={{ backgroundColor: "#ededed", borderRadius: "20px 0 0 20px", padding: "12.5px" }}>
                                   <LawsList size="tablet" link="/specificone"   color="#fff" title="قانون بیمه" number="1" />
                                   <LawsList size="tablet" link="/specifictwo"   color="#f9f9f9" title="قانون تاسیس بیمه مرکزی ایران و بیمه گری" number="2" />
                                   <LawsList size="tablet" link="/specificthree" color="#fff" title="قانون تاسیس موسسات بیمه غیر دولتی" number="3" />
                                   <LawsList size="tablet" link="/specificfour"  color="#f9f9f9" title="قانون اصلاح قانون چگونگی اداره مناطق آزاد تجاری" number="4" />
                                   <LawsList size="tablet" link="/specificfive"  color="#fff" title="قانون شخص ثالث" number="5" />
                              </Col>
                              <Col span={10} style={{ direction: "rtl", textAlign: "right", backgroundColor: "#f9f9f9", borderTopRightRadius: "20px", borderBottomRightRadius: "20px", paddingRight: "50px", boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" }}>
                                        <div className="miniCardTitleBorder" style={{
                                             position: 'absolute', left: '50%', top: '50%',
                                             transform: 'translate(-50%, -50%)'
                                        }}>
                                             <p className="miniCardTitleTablet"><strong>قوانین اختصاصی</strong></p>
                                   </div>
                              </Col>
                         </Row>
                    </Col>
                    <Col span={1}></Col>
               </Row>
          </div>

     ) : (
          <div className="LawsBackground">
               <div style={{ paddingTop: "75px" }}>
                    <Center>
                         <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile"><strong>قوانین و مقرارت</strong></p>
                    </Center>
                    <Center>
                         <Margin top={2}>
                              <p className="mainTitleDescriptionMobile">لیست قوانین و مقرارت بیمه مرکزی جمهوری اسلامی</p>
                         </Margin>
                    </Center>
               </div>
               <Row style={{ marginTop: "25px" }}>
                    <Col span={1}></Col>
                    <Col span={22}>
                         <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)" , borderRadius:"20px"}}>
                              <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px 20px 0 0" }}>
                                   <Center>
                                        <Margin top={3}>
                                             <div>
                                                  <p className="cardTitleMobile"><strong>قوانین عمومی</strong></p>
                                             </div>
                                        </Margin>
                                   </Center>
                                   <Center>
                                        <div style={{ marginTop: "-10px" }} className="cardTitleHRMobile"></div>
                                   </Center>
                              </div>
                              <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#ededed", borderRadius: "0 0 20px 20px" }}>
                                   <div style={{paddingTop:"10px"}}>
                                        <LawsList link="/generalone" color="#fff" title="قانون مبارزه با پولشویی" number="1" />
                                        <LawsList link="/generaltwo" color="#f9f9f9" title="قانون ارتقا سلامت نظام اداری" number="2" />
                                   </div>
                              </div>
                         </div>
                    </Col>
                    <Col span={1}></Col>
               </Row>
               <Row style={{ marginTop: "25px" }}>
                    <Col span={1}></Col>
                    <Col span={22}>
                         <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", borderRadius: "20px" }}>
                              <div style={{ backgroundColor: "#f9f9f9", borderRadius: "20px 20px 0 0" }}>
                                   <Center>
                                        <Margin top={3}>
                                             <div>
                                                  <p className="cardTitleMobile"><strong>قوانین اختصاصی</strong></p>
                                             </div>
                                        </Margin>
                                   </Center>
                                   <Center>
                                        <div style={{ marginTop: "-10px" }} className="cardTitleHRMobile"></div>
                                   </Center>
                              </div>
                              <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#ededed", borderRadius: "0 0 20px 20px" }}>
                                   <div style={{ paddingTop: "10px" }}>
                                        <LawsList link="/specificone"   color="#fff" title="قانون بیمه" number="1" />
                                        <LawsList link="/specifictwo"   color="#f9f9f9" title="قانون تاسیس بیمه مرکزی ایران و بیمه گری" number="2" />
                                        <LawsList link="/specificthree" color="#fff" title="قانون تاسیس موسسات بیمه غیر دولتی" number="3" />
                                        <LawsList link="/specificfour"  color="#f9f9f9" title="قانون اصلاح قانون چگونگی اداره مناطق آزاد تجاری" number="4" />
                                        <LawsList link="/specificfive"  color="#fff" title="قانون شخص ثالث" number="5" />
                                   </div>
                              </div>
                         </div>
                    </Col>
                    <Col span={1}></Col>
               </Row>
          </div>
     );
};

export default LawsMain;
